import Swal from 'sweetalert2'
import { colors } from '../../constants/colors'
// import { alertIcons } from '../../assets/icons/icons';
import './swal.style.css'

type sweetAlertIconType = {
    error: 'error';
    question: 'question',
    info: 'info',
    success: 'success',
    warning: 'warning'
}

export function swalSuccess(title?: string, option?: string, url?: any, callback?: any) {
    Swal.fire({
        icon: 'success',
        title: title,
        confirmButtonColor: colors.themeMainColor
    }).then((value) => {
        if (option === 'reset') {
        } else if (option === 'reload') {
            window.location.reload()
        } else if (option === 'go') {
            window.location.href = url
        } else if (callback != null) {
            value.isConfirmed && callback(true)
        }
    })
}

export const alertSuccess = (title: string, detail?: string, confirmButtonText?: string, callback?: () => void, finally_callback?: () => void) => {
    Swal.fire({
        title: title,
        text: detail,
        icon: "success",
        confirmButtonColor: colors.complete,
        confirmButtonText: confirmButtonText || 'ตกลง',
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-confirm-button",
            title: "custom-alert-title",
        },
        // iconHtml: `<img width={150} height={150} src="${alertIcons.successAlert2}" alt="alert-success" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    }).finally(() => {
        finally_callback && finally_callback();
    })
}
export const alertError = (title: string, detail?: string, confirmButtonText?: string, callback?: () => void) => {
    Swal.fire({
        title: title,
        text: detail,
        icon: "error",
        confirmButtonColor: colors.danger,
        confirmButtonText: confirmButtonText || 'ตกลง',
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-error-confirm-button",
            title: "custom-alert-title",
        },
        // iconHtml: `<img width="150" height="150" src="${alertIcons.errorAlert2}" alt="alert-error" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    })
}
export const alertActive = (title: string, detail?: string, confirmButtonText?: string, cancelButtonText?: string, callback?: () => void, icon?: keyof sweetAlertIconType) => {
    Swal.fire({
        title: title,
        icon: icon || 'question',
        text: detail,
        cancelButtonText: cancelButtonText || 'ยกเลิก',
        showCancelButton: true,
        confirmButtonColor: colors.complete,
        confirmButtonText: confirmButtonText || 'ตกลง',
        reverseButtons: true,
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-active-confirm-button",
            cancelButton: "custom-alert-cancel-button",
            title: "custom-alert-title",

        },
        // iconHtml: `<img width={150} height={150} src="${alertIcons.activeAlert}" alt="alert-success" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    })
}
export const alertInput = (title: string, detail?: string, confirmButtonText?: string, cancelButtonText?: string, callback?: (inputValue:string) => void, icon?: keyof sweetAlertIconType, placeholder?: string, footer?: string, maxLength?: number, required?: string,lengthErrorMessage?:string) => {
    Swal.fire({
        title: title,
        icon: icon || 'question',
        text: detail,
        html: `
        <p>${detail || ""}</p>
       <div class="p-3 mt-2" style="display:flex;justify-content:center;gap:3;align-items:center;">
        <p class="w-[350px]" style="font-size: 16px; color: gray; margin-top: 8px;">${footer}</p>
        <input
         class="w-[250px] p-2 border-2 border-s-base_secondary rounded" maxLength="${maxLength}" type="number" id="swal-input" class="swal2-input" placeholder="${placeholder || ""}"
           oninput="this.value = this.value.slice(0, 4)" 
         >
       </div>
      `,
        cancelButtonText: cancelButtonText || 'ยกเลิก',
        showCancelButton: true,
        confirmButtonColor: colors.complete,
        confirmButtonText: confirmButtonText || 'ตกลง',
        reverseButtons: true,
        inputPlaceholder: placeholder,
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-active-confirm-button",
            cancelButton: "custom-alert-cancel-button",
            title: "custom-alert-title",

        },
        preConfirm: async () => {
            try {
                const inputElement = document.getElementById('swal-input') as HTMLInputElement | null;
                if(required && lengthErrorMessage){
                    if (!inputElement || inputElement.value.trim() === '') {
                        Swal.showValidationMessage(required);
                        return null;
                    }
    
                    if (!/^\d{4}$/.test(inputElement.value)) {
                        Swal.showValidationMessage(lengthErrorMessage);
                        return null;
                    }
                    return inputElement.value;  
                }
            } catch (error) {
                Swal.showValidationMessage(`
                Request failed: ${error}
              `);
            }
        },
        allowOutsideClick: () => !Swal.isLoading()
        // iconHtml: `<img width={150} height={150} src="${alertIcons.activeAlert}" alt="alert-success" />`
    })

        .then((result) => {
            if (result.isConfirmed && callback) {
                callback(result.value);
            }
            return false
        })
}

export function swalError(title?: string) {
    Swal.fire({
        icon: 'error',
        title: title,
        confirmButtonText: 'ตกลง',
        confirmButtonColor: colors.danger
    })
}

export function swalConfirm(title: string, text: string, confirmCallback: () => void, cancelCallback?: () => void) {
    Swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: colors.themeMainColor,
        cancelButtonColor: colors.danger,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (cancelCallback) {
            cancelCallback();
        }
    });
}

export function swalActive(title?: string, text?: any, callback?: any, icon?: null | 'info' | 'warning' | 'question', confirmButtonText?: string) {
    Swal.fire({
        title: title,
        // text: text,
        html: text,
        icon: icon || 'success',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        focusConfirm: false,
        confirmButtonText: confirmButtonText || 'ส่งพิจารณา ',
        confirmButtonColor: colors.themeMainColor,
        cancelButtonText: 'ยกเลิก',
        customClass: {
            container: 'swal2-warning'
        }
    }).then((confirm) => {
        if (confirm.isConfirmed) {
            return callback(true)
        }
        return;
    })
}

export function swalSuccessAndNavigate(title: string, confirmCallback: () => void, cancelCallback?: () => void) {
    Swal.fire({
        title: title,
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: colors.themeMainColor,
        cancelButtonColor: colors.themeSecondColor,
        confirmButtonText: 'ไปที่หน้าตาราง',
        cancelButtonText: 'อยู่หน้านี้ต่อ'
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (cancelCallback) {
            cancelCallback();
        }
    });
}